<template>
  <!-- ログインも含めて全てのルートの親。
  他に、CRUDの結果を表示するグローバルスナックバーを持つ。 -->
  <v-content :style="`padding-top: ${offsetTop}px;`">
    <div
      id="core-view"
      :style="'margin-left:'+appMargin"
    >
      <SnackBar />
      <ProgressBar />
      <v-scale-transition>
        <Questionnaire v-if="showQuestionnaire" />
      </v-scale-transition>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <AppFooter />
  </v-content>
</template>

<script>
import { ProgressBar, SnackBar } from './AppView/index'
import AppFooter from './AppFooter'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Questionnaire: () => import('./AppView/Questionnaire.vue'),
    SnackBar,
    ProgressBar,
    AppFooter
  },
  metaInfo () {
    return {
      title: 'GoNOW'
    }
  },
  computed: {
    ...mapState('app', ['showQuestionnaire']),
    ...mapState('display', ['offsetTop']),
    ...mapGetters('display', ['appMargin'])
  }
}
</script>

<style lang="scss">
#core-view {
  padding-bottom: 100px;
}
.container {
  max-width: 1400px;
}
</style>
